import type {PaginatedRequest} from "@/models/pagination";
import {Role} from "@/constants/role";
import {Language} from "@/constants/language";
import type {FullNameModel} from "@/models/full-name/full-name";
import type { TableDensity } from '@/constants/density-size';
import type { FilterOptions } from '@/models/filter';

export interface User extends FullNameModel {
    id?: string;
    relationIds?: number[];
    firstName?: string;
    abbreviation?: string;
    lastName?: string;
    email: string;
    role?: Role; //null for roleless accounts (e.g. Entra-synced users not yet logged in via SSO)
    remark?: string;
    status: UserStatusModel;
    createdOn?: number;
    language: Language;
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    isSsoOnly?: boolean;
    syncedFromEntraAt?: string | null;
    activatedAt?: string | null;
    deactivatedAt?: string | null;
}

export interface UserStatusModel {
    active: boolean;
    until?: number;
}

export const DefaultUserModel = () => {
    return {
        id: undefined,
        relationIds: [],
        email: '',
        role: Role.Planner,
        fullName: '',
        remark: undefined,
        language: Language.nlNL,
        countryCode: undefined,
        phoneNumber: undefined,
        status: {
            active: false,
        }
    } as User;
}

export interface UserListRequest extends PaginatedRequest {
    email?: string;
    roles?: Role[];
    fullName?: string;
    remark?: string;
    active?: boolean;
    createdOn?: number;
    phoneNumber?: string;
    countryCode?: string;
    filterOptions: FilterOptions;
}

export interface UpdateUserStatusRequest {
    userId: string;
    active: boolean;
    from: number | undefined;
}

export const UpdateUserStatusRequestDefaults = () => {
    return {
        userId: '',
        active: true,
        from: new Date().getTime()
    } as UpdateUserStatusRequest
}

export interface UpdateUserLanguageRequest {
    id: string;
    language: Language;
}

export interface UpdateUserTableDensityRequest {
    id: string;
    tableDensity: TableDensity;
}

export interface ClientUserModel {
    fullName: string;
    email: string;
    countryCode?: string;
    phoneNumber?: string;
}